class NewMegaMenu extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        let menuTimer

        this.activeLink = this.getAttribute('data-active-link')

        let link

        if (this.closest('main-header')) {
            link = this.closest('main-header').querySelector(`.mega-menu-link-${this.activeLink.split(" ").join("-")}`)
        } else {
            const stickyHeader = this.closest('.sticky-header');
            link = stickyHeader.querySelector(`.mega-menu-link-${this.activeLink.split(" ").join("-")}`)
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === 'class') {
                        if (stickyHeader.classList.contains('show')) {
                        } else {
                            this.classList.remove('active')
                        }
                    }
                })
            })

            observer.observe(stickyHeader, { attributes: true })
        }

        link.addEventListener('mouseenter', () => {
            clearTimeout(menuTimer)
            this.classList.add('active')
        })

        link.addEventListener('mouseleave', () => {
            menuTimer = setTimeout(() => this.classList.remove('active'), 150)
        })

        this.addEventListener('mouseenter', () => {
            clearTimeout(menuTimer)
        })

        this.addEventListener('mouseleave', () => {
            this.classList.remove('active')
        })
    }
}

customElements.define('new-megamenu', NewMegaMenu);